import { z } from 'zod'

export type GradeDistribution = z.infer<typeof GradeDistributionSchema>
export const GradeDistributionSchema = z.object({
  schoolId: z.string(),
  courseCode: z.string(),
  courseName: z.string(),
  instructorName: z.string(),
  term: z.string(),
  year: z.number(),
  enrollment: z.number(),
  grades: z.object({
    A: z.number(),
    B: z.number(),
    C: z.number(),
    D: z.number(),
    F: z.number(),
    W: z.number(),
    I: z.number().optional(),
  }),
  avgGPA: z.number(),
  difficultyScore: z.number().min(0).max(10),
})
